<template>
  <div class="bar-track">
    <div
      class="bar-fill"
      :style="{ width: pct + '%', background: fillColor }"
    />
  </div>
</template>

<script setup>
import { computed } from "vue"

const props = defineProps({
  value:   { type: Number, default: 0 },
  max:     { type: Number, default: 100 },
  color:   { type: String, default: "amber" },
})

const pct = computed(() => {
  if (!props.max) return 0
  return Math.min((props.value / props.max) * 100, 100)
})

const fillColor = computed(() => {
  const map = {
    amber:  "#f5a623",
    green:  "#4ade80",
    red:    "#f87171",
    yellow: "#fbbf24",
    blue:   "#60a5fa",
    purple: "#c084fc",
  }
  return map[props.color] ?? "#f5a623"
})
</script>

<style scoped>
.bar-track {
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 2px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  border-radius: 2px;
  transition: width 0.8s ease;
}
</style>
